var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 1874,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "76 64 297.006 471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321 242.017v178.017l25.75-.267 25.75-.267.253-177.75.253-177.75H321zM159 145.5V199h52V92h-52zM76 357v178h52V179H76zm164-124.017V287H292.017l-.258-53.75-.259-53.75-25.75-.267-25.75-.267zM159 365v54h52V311h-52zm81 88v54h52V399h-52z",
    fill: "#0c0454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 255.5V281h52v-51h-52zm81 88V369h52v-51h-52z",
    fill: "#f36848"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.b6ed8692593d49a0abce10c2a7772ed1.svg";
export { ForwardRef as ReactComponent };